export default __webpack_public_path__ + "static/media/skill-comprehension-icon.a176d826.png";